export const PAGE_NAME = 'Dashboard';
